import * as React from 'react';
import {connect} from "react-redux";
import configDispatch from '../../ReduxRequests/Dispatch/configDispatch';
import configState from '../../ReduxRequests/State/configState';
import {Config} from '../../Config/dataModel';
import MaintenanceNotificationBox from '../Maintenance/MaintenanceNotificationBox';
import MaintenanceNotificationBar from '../Maintenance/MaintenanceNotificationBar';
import * as moment from 'moment';
import util from '../../Util/util';
import '../../style/maintenance.css';

interface MaintenanceNotificationProps {
    isClearable: boolean,
    fetchMaintenanceTime?: () => void,
    maintenanceTime?: Config
}

interface MaintenanceNotificationState {
    maintenanceTime: moment.Moment
}

class MaintenanceNotification extends React.Component<MaintenanceNotificationProps, MaintenanceNotificationState> {
    public constructor(props: MaintenanceNotificationProps) {
        super(props);
        this.state = {
            maintenanceTime: null
        };
    }

    public componentDidMount() {
        this.props.fetchMaintenanceTime();
    }

    public componentWillReceiveProps(nextProps: MaintenanceNotificationProps) {
        if (nextProps.maintenanceTime && nextProps.maintenanceTime !== this.props.maintenanceTime) {
            this.setState({
                maintenanceTime: util.getDate(nextProps.maintenanceTime.fieldValue)
            });
        }
    }

    public render() {
        return this.state.maintenanceTime && 
        (this.props.isClearable ? 
            <MaintenanceNotificationBox maintenanceTime={this.state.maintenanceTime}/> :
            <MaintenanceNotificationBar maintenanceTime={this.state.maintenanceTime}/>);
    }
}

export default connect(configState, configDispatch)(MaintenanceNotification);



// WEBPACK FOOTER //
// ./src/Components/Maintenance/MaintenanceNotification.tsx